import { Language, Translation } from "../types";

export const translations: Record<Language, Translation> = {
  en: {
    title: "QR code generator",
    subtitle: "Design a QR code people actually enjoy scanning.",
    qrType: "What are you sharing?",
    url: "Link",
    text: "Text",
    wifi: "Wi-Fi",
    email: "Email",
    ssid: "Network name",
    password: "Password",
    encryption: "Security type",
    emailAddress: "Send to",
    subject: "Subject",
    body: "Message",
    qrSize: "Size",
    fgColor: "Code color",
    bgColor: "Background color",
    generate: "Generate QR code",
    yourQR: "Your QR code",
    download: "Download PNG",
    customize: "Make it yours",
    placeholderUrl: "https://yoursite.com",
    placeholderText: "Type anything you'd like to encode",
    placeholderSSID: "e.g. Home-5G",
    placeholderPassword: "Enter the Wi-Fi password",
    placeholderEmail: "name@example.com",
    placeholderSubject: "What's this about?",
    placeholderBody: "Write your message",
    centerImage: "Add a logo (optional)",
    uploadImage: "Choose image",
    removeImage: "Remove",
    imageSize: "Logo size",
    excavate: "Clear space behind logo",
    emptyState: "Fill in the details on the left, then generate your code.",
    encryptionWpa: "WPA/WPA2",
    encryptionWep: "WEP",
    encryptionNone: "Open network (none)",
  },
  vi: {
    title: "Trình tạo mã QR",
    subtitle: "Tạo mã QR mà người quét sẽ thấy thích thú, chỉ trong vài giây.",
    qrType: "Bạn muốn chia sẻ điều gì?",
    url: "Liên kết",
    text: "Văn bản",
    wifi: "Wi-Fi",
    email: "Email",
    ssid: "Tên mạng Wi-Fi",
    password: "Mật khẩu",
    encryption: "Loại bảo mật",
    emailAddress: "Gửi đến",
    subject: "Tiêu đề",
    body: "Nội dung thư",
    qrSize: "Kích thước",
    fgColor: "Màu mã",
    bgColor: "Màu nền",
    generate: "Tạo mã QR",
    yourQR: "Mã QR của bạn",
    download: "Tải xuống PNG",
    customize: "Tùy chỉnh theo ý bạn",
    placeholderUrl: "https://trangweb-cua-ban.com",
    placeholderText: "Nhập nội dung bạn muốn mã hóa",
    placeholderSSID: "vd: Nha-5G",
    placeholderPassword: "Nhập mật khẩu Wi-Fi",
    placeholderEmail: "ten@vidu.com",
    placeholderSubject: "Nội dung là gì?",
    placeholderBody: "Viết nội dung của bạn",
    centerImage: "Thêm logo (tùy chọn)",
    uploadImage: "Chọn ảnh",
    removeImage: "Xóa ảnh",
    imageSize: "Kích thước logo",
    excavate: "Làm trống nền sau logo",
    emptyState: "Điền thông tin bên trái rồi tạo mã QR của bạn.",
    encryptionWpa: "WPA/WPA2",
    encryptionWep: "WEP",
    encryptionNone: "Mạng mở (không mật khẩu)",
  },
};
